import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    locationEnabled: false,
    cameraEnabled: false,
    location: null,
    curDoc: null,
    token: null,
    user: null,
    url: null,
  },
  getters: {
    getToken(state) {
      return state.token;
    },
    getUrl(state) {
      return state.url;
    }
  },
  mutations: {
    setLocationEnable(state, locationEnabled) {
      state.locationEnabled = locationEnabled;
    },
    setCameraEnabled(state, cameraEnabled) {
      state.cameraEnabled = cameraEnabled;
    },
    setLocation(state, location) {
      state.location = location;
    },
    setCurDoc(state, curDoc) {
      state.curDoc = curDoc;
    },
    setToken(state, token) {
      state.token = token;
    },
    setUser(state, user) {
      state.user = user;
    },
    setUrl(state, url) {
      state.url = url;
    }
  },
  actions: {
  }
})
